import { PlaylistAdd } from "@mui/icons-material";
import { Button } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { isMaxItemsReached } from "@ryde/shared";

import { AvailabilityItemEdit } from "./availability-item.edit";
import {
  emptyAvailability,
  IAvailabilityItemForm,
} from "./table-availability.models";

export const AvailabilityItemAdd: FC<IAvailabilityItemForm> = ({
  index,
  setValueOuter,
  fieldName,
  formAttributes,
  onEditStart,
  onEditEnd,
}) => {
  const { t } = useTranslation();
  const [isAddNewOpened, setAddNewOpenedState] = useState(false);
  const hideAppendButton = isMaxItemsReached(
    formAttributes?.maxItemsToAdd,
    index || 0,
  );

  useEffect(() => {
    if (isAddNewOpened) {
      onEditStart?.();
    } else {
      onEditEnd?.();
    }
  }, [isAddNewOpened, onEditStart, onEditEnd]);

  return (
    <>
      {isAddNewOpened && (
        <AvailabilityItemEdit
          fieldName={`${fieldName}[${index || 0}]`}
          setValueOuter={setValueOuter}
          value={emptyAvailability}
          index={index}
          formAttributes={formAttributes}
          onCancelOuter={() => {
            setAddNewOpenedState(false);
          }}
        />
      )}
      {!isAddNewOpened && !hideAppendButton && (
        <Button
          type="button"
          size="medium"
          className="add_button"
          startIcon={<PlaylistAdd />}
          onClick={() => setAddNewOpenedState(true)}
        >
          {t("general.APPEND")}
        </Button>
      )}
    </>
  );
};
